import React, { useState, useEffect } from "react";
import ResumeUseForm from "../../hooks/editor/resumeUseForm";
import Quilleditor from "../../Components/Quilleditor/Quilleditor";
import CarouselSlider from "../../Components/Caurosel/Carousel";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import "./CoverEditor.scss";

function Content({
  title,
  sectionId,
  resumeFields,
  setResumeFields,
  handleEditorChange,
  resumeUpdate,
  resumeHandler,
  changeHeaderSettings,
}) {
  const [content, setContent] = useState("");
  const dispatch = useDispatch();
  const { id } = useParams();
  const [show, setShow] = useState(true);
  const [job, setJob] = useState(true);
  const [suggestion, setSuggestion] = useState(false);
  const userInfo = useSelector((state) => state.particularuser.user);
  const fromData = useSelector((state) => state.editorData.from);

  const showSuggestion = () => {
    setSuggestion(!suggestion);
    setShow(!show);
  };
  const changesetShowQuillToolbar = (status) => {};

  useEffect(() => {
    setJob(
      fromData &&
        fromData.data &&
        fromData.data[0] &&
        fromData.data[0].job_title
    );
  }, [fromData]);

  const sectionClick = () => {};
  // useEffect(() => {
  // 	dispatch(userParticularGet(id, true));
  // }, [dispatch]);

  return (
    <div className="card pb-3 mb-4">
      <div className="card-header d-flex justify-content-between align-items-center bg-white">
        <h4 className="card-title">{title}</h4>
      </div>

      {resumeFields && resumeFields.content && resumeFields.content && (
        <>
          <div className="cover-content-div">
            <div className="col-md-12 cover-quill-editor mb-3 mt-2">
              <label>
                3-4 paragraphs explaining why you're the perfect candidate for a
                specific job
              </label>

              <div
                style={{
                  backgroundColor: "#edf0f1",
                  padding: "2px",
                  borderRadius: "6px",
                }}
              >
                <Quilleditor
                  showQuillToolbar={true}
                  changesetShowQuillToolbar={changesetShowQuillToolbar}
                  theme="snow"
                  inivalue={
                    resumeFields &&
                    resumeFields.content &&
                    resumeFields.content.description?.replace(/\n|\r/g, "")
                  }
                  current={0}
                  setvalue={handleEditorChange}
                  sectionId={sectionId}
                  onBlur={resumeUpdate}
                  placeholder="Show your relevant experience (last 10 years). Use bullet points to note your achievements. if possible - use numbers/facts (Achieved X, measured by Y, by doing Z)"
                />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Content;
